import AppSidebar from "../../../../../components/Sidebar/AppSidebar";

const MobileLeftSideBarComponent = () => <AppSidebar />;

export default MobileLeftSideBarComponent;
